<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '1px' }"></ngx-loading>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
